import { render, staticRenderFns } from "./ChannexIncidentModal.vue?vue&type=template&id=e5e006ea&scoped=true"
import script from "./ChannexIncidentModal.vue?vue&type=script&lang=js"
export * from "./ChannexIncidentModal.vue?vue&type=script&lang=js"
import style0 from "./ChannexIncidentModal.vue?vue&type=style&index=0&id=e5e006ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e006ea",
  null
  
)

export default component.exports